// extracted by mini-css-extract-plugin
export var active = "styles-module__active___qy0qA";
export var button = "styles-module__button___ABIpz";
export var translateIcon = "styles-module__translateIcon___ikKPy";